import { Component, Input } from '@angular/core';

@Component({
  selector: 'nc-animated-shiny-text',
  templateUrl: './animated-shiny-text.component.html',
  styleUrls: ['./animated-shiny-text.component.less'],
})
export class AnimatedShinyTextComponent {
  @Input() ncText: string = '';
  @Input() ncShimmerWidth: number = 100;
  @Input() ncTheme: 'light' | 'dark' = 'light';
}
